export enum Operation {
    /// Equal
    eq = "eq",
    /// neq = 'neq',
    /// like
    like = "like",
    /// Greater than
    gt = "gt",
    /// Greater than or equal
    gte = "gte",
    /// Less than
    lt = "lt",
    /// Less than or equal
    lte = "lte",
    /// Between
    btn = "btn", // between
    // any = "any",
    in = "in",
}

export enum TableDefaults {
    page = 0,
    size = 25,
}
